import { render, staticRenderFns } from "./supplierBinding.vue?vue&type=template&id=bbd4b414&scoped=true"
import script from "./supplierBinding.vue?vue&type=script&lang=js"
export * from "./supplierBinding.vue?vue&type=script&lang=js"
import style0 from "./supplierBinding.vue?vue&type=style&index=0&id=bbd4b414&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd4b414",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbd4b414')) {
      api.createRecord('bbd4b414', component.options)
    } else {
      api.reload('bbd4b414', component.options)
    }
    module.hot.accept("./supplierBinding.vue?vue&type=template&id=bbd4b414&scoped=true", function () {
      api.rerender('bbd4b414', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dental/product/supplierBinding.vue"
export default component.exports